import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { Activity, ActivityState, Organization, OrganizationState, Participant, ParticipantState } from '@app/_store';
import { Store } from '@ngxs/store';
import { Observable, map } from 'rxjs';
import { NgIf, AsyncPipe } from '@angular/common';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { SupportIconComponent } from '../../../../navigation/support-icon/support-icon.component';
import { AccountComponent } from '../../../../navigation/account/account.component';

@Component({
  selector: 'app-activity-navigation',
  templateUrl: './activity-navigation.component.html',
  styleUrls: ['./activity-navigation.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgIf, RouterLink, RouterLinkActive, SupportIconComponent, AccountComponent, AsyncPipe],
})
export class ActivityNavigationComponent {
  organization$: Observable<Organization> = inject(Store).select(OrganizationState.current);

  activity$: Observable<Activity> = inject(Store).select(ActivityState.currentActivity);

  participants$: Observable<Participant[]> = inject(Store).select(ParticipantState.participants);

  anyDeliverableProducts(): Observable<boolean> {
    return this.activity$.pipe(
      map(activity => {
        const haveDeliverableProducts =
          activity && activity.products && activity.products.filter(p => p.isDeliverable).length > 0;
        const isKakserviceIntegration =
          activity &&
          activity.integrationData &&
          activity.integrationData['kakservice'] &&
          activity.integrationData['kakservice']['orderDate'];
        return haveDeliverableProducts || isKakserviceIntegration;
      })
    );
  }
}
